function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "25.204",
  height: "13.179"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_3918",
  "data-name": "Group 3918",
  transform: "translate(-283 -796.879)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_300",
  "data-name": "Path 300",
  d: "M8.153 6.478a2.607 2.607 0 112.607-2.607 2.611 2.611 0 01-2.607 2.607m0-3.362a.755.755 0 10.755.755.759.759 0 00-.755-.755",
  transform: "translate(297.445 800.862)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3919",
  "data-name": "Group 3919",
  transform: "translate(283 799.484)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_301",
  "data-name": "Path 301",
  d: "M11.54 9.86C5.8 9.86.958 7.864.958 5.5c0-2.138 3.969-3.962 8.962-4.3a1.722 1.722 0 01-.112-.551 1.566 1.566 0 01.084-.4C4.238.607 0 2.772 0 5.5c0 2.985 5.069 5.322 11.54 5.322 5.169 0 9.395-1.5 10.9-3.625a1.69 1.69 0 01-.9-.364c-1.406 1.736-5.391 3.031-10 3.031",
  transform: "translate(0 -.243)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_302",
  "data-name": "Path 302",
  d: "M11.826 4.154a1.657 1.657 0 01.908-.36C11.381 1.909 7.868.53 3.462.246a1.6 1.6 0 01.084.406 1.766 1.766 0 01-.111.548c3.9.261 7.146 1.437 8.391 2.954",
  transform: "translate(9.726 -.246)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_303",
  "data-name": "Path 303",
  d: "M3.655 3.126a.868.868 0 10-.87-.87.869.869 0 00.87.87",
  transform: "translate(290.886 802.477)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_303_-_Outline",
  "data-name": "Path 303 - Outline",
  d: "M3.655 3.626a1.368 1.368 0 111.37-1.37 1.371 1.371 0 01-1.37 1.37zm0-1.736a.368.368 0 10.37.366.368.368 0 00-.37-.366z",
  transform: "translate(290.886 802.477)",
  fill: "#282828"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_304",
  "data-name": "Path 304",
  d: "M5.264 5.209a2.6 2.6 0 112.6-2.6 2.608 2.608 0 01-2.6 2.6m0-3.359a.755.755 0 10.755.755.758.758 0 00-.755-.755",
  transform: "translate(289.276 796.879)"
}))));